/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { limitedOperators } from 'cio/utils/conditions-operators';
import AttributeCondition from 'cio/app-models/conditions/attribute';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import CollectionAttributeCondition from 'cio/app-models/conditions/collection-attribute';
import CampaignModel from 'cio/models/campaign';
import { ConditionEditorSubLayout } from 'cio/utils/condition-editor';
import convertOperator from 'cio/utils/operators/convert';

interface EditorArgs {
  condition?: AttributeCondition | EventAttributeCondition | CollectionAttributeCondition;
  campaign?: CampaignModel;
  disabled?: boolean;
  attributes: Record<string, any>;
  variation?: string;
  subLayout?: ConditionEditorSubLayout;
  direction?: string;
  size?: string;
  gapSize?: string;
  dropdownClass?: string;
  marginClass?: string;
  allowComparisonOperator?: boolean;
  allowArrayOperators?: boolean;
  allowedConditionOperators?: string[] | null;
  autosuggestValueOverrides?: Record<string, string[]>;
  isLoadingAutosuggestValueOverrides?: boolean;
  showEventNameInEditor?: boolean;
  onConditionChange?: () => unknown;
  allowJsonOperators?: boolean;
  isJsonChild?: boolean;
}

export default class Editor extends Component<EditorArgs> {
  get limitedOperators() {
    let operators: string[] = limitedOperators.map((operator) => convertOperator(operator.value));

    if (this.args.allowedConditionOperators != null) {
      operators.push(...this.args.allowedConditionOperators);
    }

    return operators.uniq();
  }

  get showEventNameInEditor() {
    return this.args.showEventNameInEditor ?? true;
  }

  get allowJsonOperators() {
    return this.args.allowJsonOperators ?? false;
  }

  get isJsonChild() {
    return this.args.condition?.isJsonChild ?? false;
  }
}
